import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/services/core/http.service';

type ViewState = 'form' | 'success' | 'error';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  private route = inject(ActivatedRoute);
  private httpService = inject(HttpService);
  viewState: ViewState = 'form';
  myOrigin = window.location.origin;
  successText2 = "";
  languageJSON: any;

  loading = false;
  showPassword = false;
  showPasswordConfirmation = false;

  token = '';
  email = '';

  readonly passwordPattern = /^(?=.*\d)(?=.*[A-Za-z])(?!.*\s).{8,200}$/;

  form = new FormGroup({
    password: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern(this.passwordPattern)],
    }),
    password_confirmation: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, Validators.pattern(this.passwordPattern)],
    }),

  }, { validators: this.checkPasswords });

  private checkPasswords(control: AbstractControl): ValidationErrors | null {
    const pass = control.get('password')?.value;
    const confirmPass = control.get('password_confirmation')?.value;
    return pass === confirmPass ? null : { notSame: true };
  }

  get registerPasswordsMatch() {
    return this.form.hasError('notSame');
  }

  get password() {
    return this.form.get('password');
  }

  get password_confirmation() {
    return this.form.get('password_confirmation');
  }

  ngOnInit(): void {
    let lang = "";

    this.route.queryParamMap
      .subscribe((map) => {
        const token = map.get('token');
        const email = map.get('email');
        lang = map.get('lang') ?? "en";
        this.token = token || '';
        this.email = email || '';
      });

    if (!this.token || !this.email) {
      this.viewState = 'error';
    }

    this.httpService.getLanguageJSON(lang || "en").subscribe((languageJSON) => {
      this.languageJSON = languageJSON;
      this.successText2 = this.languageJSON.ResetPassword_SuccesText2.replaceAll("$myOrigin", this.myOrigin);
      document.getElementById("loading-screen")?.remove();
    });
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  togglePasswordConfirmation(): void {
    this.showPasswordConfirmation = !this.showPasswordConfirmation;
  }

  onSubmit(): void {
    if (this.loading || this.form.invalid) return;

    this.loading = true;

    this.httpService.resetPassword(this.token, this.email, this.form.value.password!, this.form.value.password!).subscribe({
      next: () => {
        this.viewState = 'success';
        this.loading = false;
      },
      error: (error) => {
        this.viewState = 'error';
        this.loading = false;
      }
    });
  }
}
